/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Queues_Queue_NameInputs */

const en_tables_queues_queue_name = /** @type {(inputs: Tables_Queues_Queue_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Name`)
};

const de_tables_queues_queue_name = /** @type {(inputs: Tables_Queues_Queue_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Name`)
};

/**
* | output |
* | --- |
* | "Queue Name" |
*
* @param {Tables_Queues_Queue_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_queues_queue_name = /** @type {((inputs?: Tables_Queues_Queue_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Queues_Queue_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_queues_queue_name(inputs)
	return de_tables_queues_queue_name(inputs)
});